<template>
  <div class="teacher">
    <div id="content">
      <div class="headline font24" v-if="showData.titleShow === 1">
        <span>{{showData != null? showData.title:''}}</span>
        <span class="more font14" @click="toNextList(showData)" v-if="showData.moreShow === 1">更多<img style="height: 12px;margin-left: 2px;position: relative;top: 1px;" src="/static/images/more.png" alt=""></span>
      </div>
      <div class="teacherbox">
        <Row v-if="showData != null">
          <Col span="4" v-for="(item,index) in showData.infos.slice(0,6)" :key="index">
            <div class="teacon">
              <div class="imgbox">
                <img :src="setimg(item.picPath,$configUrl.futureImgUrl)" alt="">
                <div class="mark">
                  <p class="font14" v-html="setStr(item.text3)"></p>
                </div>
               </div>
               <div class="teaintro">
                  <div class="introhead font22">{{item.text1}}</div>
                  <div class="introtext font14" :title="item.text2?item.text2:''">{{item.text2?item.text2:''}}</div>
               </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
  import bus from '../../assets/eventBus/enentBus.js'
  export default {
    name: 'indexTeacher',
    props:{
      showData:{
        type:Object,
        default:null
      }
    },
    data () {
      return {
        tabactive:1,
        msg:'tab1',
        teacherList:[],
        toNextListStr:''
      }
    },
    computed:{
      setStr(){
        return (val)=> {
          const value = val ? val.replace(/\r/g, '<br>') : ''
          return value
        }
      },
      setimg(){
        return (val,imgpath)=> {
          const value = imgpath + val
          return value
        }
      },
      setMoreUrl(){
        return (str)=>{
          let arr = [];
          arr = str.split('?')
          this.toNextListStr = arr[0]
          return this.toNextListStr
        }
      },
      setMoreUrlId(){
        return (str)=>{
          let arr = [];
          let arr1 = [];
          let str1 = '';
          let arr2 = [];
          let data = {}
          arr = str.split('?')
          this.toNextListStr = arr[0];
          str1 = arr[1];
          arr1 = str1.split('&')
          for(let i = 0; i < arr1.length; i++){
            arr2.push(arr1[i].split('='))

          }
          console.log('arr2',arr2)

          for(let i=0;i<arr2.length;i++){
            data[arr2[i][0]] = arr2[i][1]

          }
          //这是俩参数
          //return data;
          return data.plate_id
        }
      },
    },
    mounted() {
      //console.log(this.showData.infos.slice(0,6))
    },
    methods:{
      toNextList(obj){
        this.$router.push({ path: obj.moreUrl,query:{name:encodeURI(obj.title)}});
         this.$nextTick(()=>{
           $("body").scrollTop(0);
         })

       },
    }
  }
</script>

<style scoped="scoped">
  #content {
    width: 1200px;
  }
  .teacher {
    padding-bottom: 60px;
  }
  .headline {
    text-align: left;
    line-height: 1.8;
    border-bottom: 2px solid #3583FF;
    position: relative;
    padding-top: 50px;
    font-weight: 500;
  }
  .headline .more {
    color: #3583FF;
    float: right;
    position: relative;
    top: 10px;
    cursor: pointer;
  }
  .teacherbox {
    padding-top: 45px;
  }
  .teacon .imgbox {
    width: 80%;
    margin: 0 auto;
    position: relative;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    line-height: 1;
  }
  .teacon .imgbox img {
    width: 100%;
    line-height: 1;
  }
  .teacon .imgbox .mark {
    position: absolute;
    left: 0;
    top: 500px;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.5);
    transition: all .5s;
    line-height: 1.5;
  }
  .teacon .imgbox .mark p {
    position: absolute;
    padding: 0 15px;
    bottom: 15px;
    left: 0;
    text-align: left;
    color: #fff;
  }
  .teacon .imgbox:hover .mark {
    top: 0;
    transition: all .5s;
  }
  .teaintro {
    background: #577EF6;
    border-radius: 8px;
    position: relative;
    top: -2px;
    padding-bottom: 10px;
    width: 90%;
    margin: 0 auto;
  }
  .teaintro .introhead {
    color: #fff;
    width: 90%;
    margin: 0 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-top: 8px;
    font-size: 18px;
  }
  .teaintro .introtext {
    width: 70%;
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: linear-gradient(180deg, #FEE0BA 0%, #F5D1AB 100%);
    border-radius: 4px;
    font-size: 12px;
    color: #794409;
    font-weight: 600;
    margin: 6px auto 0;
    padding: 0 5px;
  }
  @media screen and (min-width: 1920px) {
    #content {
      width: 87.5%;
    }
    .teaintro .introhead {
      font-size: 22px;
    }
    .teaintro .introtext {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexContent/teacher.vue